import React from 'react';
import { Page } from '@fiverr-private/perseus';
import { CMSContextProvider } from '@fiverr-private/cms_ui/src/content_types/CMSProvider';
import BIEvents from '../utils/BIEvents';
import LandingPage from '../components/LandingPage/component/LandingPage';

class StaticPagesApp extends Page {
    componentDidMount() {
        const { context, pageName } = this.props;
        const { page_ctx_id, current_user, params } = context;
        const user_id = current_user && current_user.id;
        const { source } = params; // TODO: source is always undefined

        BIEvents.initialize({ userId: user_id, pageCtxId: page_ctx_id });
        BIEvents.mixpanelPageView({ source, pageName });
        BIEvents.sendBigQueryPageViewEvent(pageName, { source });
    }

    render() {
        const { currencyObj } = this.props;

        return (
            <CMSContextProvider value={{
                perseus_name: 'static_pages',
                base_path: 'static_pages',
                additionalProps: { context: this.props.context },
                currencyObj
            }}>
                <LandingPage {...this.props.data}/>
            </CMSContextProvider>
        );
    }
}

export default StaticPagesApp;
